/* Happily Puzzles cart enhancements
   - 15-min countdown timer (urgency)
   - "Don't forget your free mini puzzle" reminder
   - Mini puzzle upsell for 1000-piece buyers (Foodies puzzle)
*/
(function () {
  'use strict';

  var MINI_TYPE        = 'mini puzzle';        // compared lowercase
  var BIG_TYPE         = '1,000 piece puzzle'; // compared lowercase
  var COUNTDOWN_MINS   = 15;
  var FOODIES_HANDLE   = 'robot-99-piece-mini-jigsaw-puzzle-copy';

  var timerInterval       = null;
  var timerEndMs          = null;
  var cartOpenedThisLoad  = false; // suppress repeat auto-opens
  var rerendering         = false; // prevent fix-stale loops

  /* ── Timer helpers ─────────────────────────────────────────────── */
  function fmt(s) {
    return String(Math.floor(s / 60)).padStart(2, '0') + ':' +
           String(s % 60).padStart(2, '0');
  }

  function startTimer() {
    timerEndMs = Date.now() + COUNTDOWN_MINS * 60000;
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  function tick() {
    var el = document.getElementById('happily-timer');
    if (!el) return;
    var r = Math.max(0, Math.round((timerEndMs - Date.now()) / 1000));
    el.textContent = fmt(r);
    if (r === 0) { clearInterval(timerInterval); timerInterval = null; }
  }

  function stopTimer() {
    if (timerInterval) { clearInterval(timerInterval); timerInterval = null; }
  }

  function ensureTimerBanner() {
    if (document.getElementById('happily-countdown')) return;
    var b = document.createElement('div');
    b.id = 'happily-countdown';
    b.className = 'happily-countdown';
    b.innerHTML = '⏱ Your cart is held for <strong><span id="happily-timer">' +
                  fmt(COUNTDOWN_MINS * 60) + '</span></strong>';
    var h = document.querySelector('#CartDrawer .drawer__header');
    if (h) h.insertAdjacentElement('afterend', b);
  }

  /* ── Money format ───────────────────────────────────────────────── */
  function moneyFmt(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  /* ── Fix stale cart drawer ──────────────────────────────────────── */
  // If cart has items but the drawer is still showing the empty-state HTML
  // (happens when the page loaded with an empty cart then items were added),
  // fetch a fresh section render from Shopify and let Dawn inject it.
  function fixStaleCartIfNeeded(cart) {
    if (rerendering) return;
    var itemsEl = document.querySelector('cart-drawer-items');
    if (!itemsEl) return;
    if (cart.item_count === 0 || !itemsEl.classList.contains('is-empty')) return;

    rerendering = true;
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && typeof drawerEl.renderContents === 'function') {
          drawerEl.renderContents({ sections: sections });
          // Re-apply our enhancements after Dawn re-renders
          setTimeout(function () {
            rerendering = false;
            refreshCart();
          }, 200);
        } else {
          rerendering = false;
        }
      })
      .catch(function () { rerendering = false; });
  }

  /* ── Fetch & update cart enhancements ──────────────────────────── */
  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(applyEnhancements)
      .catch(function () {});
  }

  function applyEnhancements(cart) {
    fixStaleCartIfNeeded(cart);
    var miniQty = 0;
    var hasBig  = false;
    cart.items.forEach(function (item) {
      var type = (item.product_type || '').toLowerCase();
      if (type === MINI_TYPE) miniQty += item.quantity;
      if (type === BIG_TYPE)  hasBig   = true;
    });
    updateMiniReminder(miniQty);
    updateUpsell(hasBig, miniQty > 0);
  }

  /* ── "Don't forget your free mini puzzle" reminder ─────────────── */
  function updateMiniReminder(miniQty) {
    var freeN = Math.floor(miniQty / 5);
    var el    = document.getElementById('happily-reminder');

    if (freeN >= 1 && miniQty < freeN * 6) {
      if (!el) {
        el = document.createElement('div');
        el.id = 'happily-reminder';
        el.className = 'mini-puzzle-reminder';
        var bar = document.querySelector('.free-shipping-bar');
        if (bar) bar.insertAdjacentElement('afterend', el);
      }
      var p = freeN > 1;
      el.innerHTML =
        '🎁 Don\'t forget! Your order comes with ' +
        (p ? '<strong>' + freeN + ' free mini puzzles</strong>'
           : 'a <strong>free mini puzzle</strong>') +
        ' — add ' + (p ? 'them' : 'it') + ' to your cart before checking out!';
    } else if (el) {
      el.remove();
    }
  }

  /* ── Mini puzzle upsell (for 1000-piece buyers) ─────────────────── */
  function updateUpsell(hasBig, hasMini) {
    var el = document.getElementById('happily-upsell');

    if (hasBig && !hasMini) {
      if (!el) {
        el = document.createElement('div');
        el.id = 'happily-upsell';
        el.className = 'happily-upsell';
        el.innerHTML =
          '<p class="happily-upsell__title">Why not try one of our 99-piece mini puzzles?</p>' +
          '<div class="happily-upsell__list" id="happily-upsell-list"><small>Loading…</small></div>';
        var footer = document.querySelector('#CartDrawer .drawer__footer');
        if (footer) footer.insertAdjacentElement('beforebegin', el);
        loadFoodiesPuzzle();
      }
    } else if (el) {
      el.remove();
    }
  }

  function loadFoodiesPuzzle() {
    fetch('/products/' + FOODIES_HANDLE + '.json')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = document.getElementById('happily-upsell-list');
        if (!list || !d.product) return;

        var p    = d.product;
        var v    = p.variants[0];
        var name = p.title.replace(' - 99 Piece Mini Jigsaw Puzzle', '');
        var img  = p.images[0]
          ? p.images[0].src.replace(/(\.[a-z]+)(\?.*)?$/, '_80x80$1')
          : '';
        var price = moneyFmt(Math.round(parseFloat(v.price) * 100));

        list.innerHTML =
          '<div class="happily-upsell__item">' +
          (img ? '<img src="' + img + '" alt="' + name + '" width="56" height="56">' : '') +
          '<div class="happily-upsell__info">' +
            '<a href="/products/' + p.handle + '" class="happily-upsell__name">' + name + '</a>' +
            '<span class="happily-upsell__price">' + price + '</span>' +
          '</div>' +
          '<button type="button" class="button button--secondary happily-upsell__add" data-vid="' + v.id + '">Add</button>' +
          '</div>';

        list.querySelectorAll('.happily-upsell__add').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var b = this;
            b.disabled = true;
            b.textContent = '…';
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(b.dataset.vid), quantity: 1 }] })
            })
            .then(function (r) { return r.json(); })
            .then(function () {
              b.textContent = '✓ Added';
              // Re-render the full cart drawer so the new item appears immediately
              // in the sidebar (not just at checkout). Our patched renderContents
              // will also call refreshCart() which hides the upsell (hasMini = true).
              fetch('/?sections=cart-drawer,cart-icon-bubble')
                .then(function (r) { return r.json(); })
                .then(function (sections) {
                  var drawerEl = document.querySelector('cart-drawer');
                  if (drawerEl && typeof drawerEl.renderContents === 'function') {
                    drawerEl.renderContents({ sections: sections });
                  } else {
                    refreshCart();
                  }
                })
                .catch(function () { refreshCart(); });
            })
            .catch(function () {
              b.textContent = 'Add';
              b.disabled = false;
            });
          });
        });
      })
      .catch(function () {
        var list = document.getElementById('happily-upsell-list');
        if (list) list.innerHTML = '<a href="/collections/mini-puzzles" class="link">Browse Mini Puzzles →</a>';
      });
  }

  /* ── Cart open / close ──────────────────────────────────────────── */
  function onCartOpen() {
    if (!cartOpenedThisLoad) {
      cartOpenedThisLoad = true;
      ensureTimerBanner();
      stopTimer();
      startTimer();
    }
    refreshCart();
  }

  function onCartClose() {
    stopTimer();
  }

  /* ── Initialise ─────────────────────────────────────────────────── */
  function init() {
    customElements.whenDefined('cart-drawer').then(function () {
      var Cls = customElements.get('cart-drawer');
      if (!Cls) return;
      var proto = Cls.prototype;

      if (!proto.__happilyPatched) {
        if (proto.open) {
          var origOpen = proto.open;
          proto.open = function () {
            var triggeredBy = arguments[0];
            var isAutoOpen  = !(triggeredBy instanceof Element);

            if (isAutoOpen && cartOpenedThisLoad) {
              refreshCart();
              return;
            }

            var result = origOpen.apply(this, arguments);
            onCartOpen();
            return result;
          };
        }

        if (proto.close) {
          var origClose = proto.close;
          proto.close = function () {
            var result = origClose.apply(this, arguments);
            onCartClose();
            return result;
          };
        }

        if (proto.renderContents) {
          var origRenderContents = proto.renderContents;
          proto.renderContents = function () {
            var result = origRenderContents.apply(this, arguments);
            setTimeout(refreshCart, 150);
            return result;
          };
        }

        proto.__happilyPatched = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Newsletter CTA scroll ─────────────────────────────────────────────
   Intercepts clicks on announcement-bar newsletter links and smoothly
   scrolls to the footer newsletter section, offset for the sticky header.
   Uses event delegation on document so it works on both desktop and mobile
   regardless of when the announcement bar is rendered.
────────────────────────────────────────────────────────────────────── */
(function newsletterCTAScroll() {
  var SELECTORS = [
    '.announcement-bar__link',
    '.announcement-bar__announcement a',
    '.announcement-bar a'
  ];

  function closestMatch(el) {
    // Walk up the DOM to find a matching ancestor
    while (el && el !== document.body) {
      for (var i = 0; i < SELECTORS.length; i++) {
        if (el.matches && el.matches(SELECTORS[i])) return el;
      }
      el = el.parentElement;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest
      ? e.target.closest(SELECTORS.join(', '))
      : closestMatch(e.target);
    if (!a) return;

    var href = (a.getAttribute('href') || '').trim();
    if (href.charAt(0) !== '#') return;
    var targetId = href.slice(1);
    if (!targetId) return;

    var target = document.getElementById(targetId);
    if (!target) target = document.querySelector('[id$="__newsletter"]');
    if (!target) return;

    e.preventDefault();

    var headerEl = document.querySelector('.section-header');
    var offset = headerEl ? headerEl.offsetHeight + 8 : 16;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    // Use smooth scroll with fallback for older mobile browsers
    try {
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } catch (err) {
      window.scrollTo(0, Math.max(0, top));
    }
  }, true); // capture phase ensures we fire before Dawn's own handlers
})();

/* ── Card title split ──────────────────────────────────────────────
   Splits product card titles at ' - ' so name and type are on
   separate lines: "Art Cats - 1,000 Piece" → name span + type span.
   Runs once on DOMContentLoaded; CSS handles the two-line layout.
────────────────────────────────────────────────────────────────────── */
(function splitCardTitles() {
  function run() {
    document.querySelectorAll('.card__heading a.full-unstyled-link').forEach(function (a) {
      // Skip if already split
      if (a.querySelector('.card-title__name')) return;
      var text = a.textContent.trim();
      var idx  = text.indexOf(' - ');
      if (idx < 0) return;
      var name = text.slice(0, idx);
      var type = text.slice(idx + 3);
      a.innerHTML =
        '<span class="card-title__name">' + name + '</span>' +
        '<span class="card-title__type">' + type + '</span>';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* ── Sticky Add-to-Cart Bar ─────────────────────────────────────────
   Only activates on product pages. Appears when the main ATC button
   scrolls out of view. Clicking it triggers the main product form.
────────────────────────────────────────────────────────────────────── */
(function stickyATC() {
  if (!document.body.classList.contains('template-product')) return;

  var bar = null;
  var mainBtn = null;
  var observer = null;

  function moneyFmtStr(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function updateStickyPrice() {
    var stickyPrice = document.getElementById('happily-sticky-price');
    if (!stickyPrice) return;
    // Try to read from the visible price element on the PDP
    var priceEl = document.querySelector(
      '.price__regular .price-item--regular, .price-item--regular'
    );
    if (priceEl) stickyPrice.textContent = priceEl.textContent.trim();
  }

  function createBar() {
    if (document.getElementById('happily-sticky-atc')) return;

    mainBtn = document.querySelector('button[name="add"].product-form__submit');
    if (!mainBtn) return;

    var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__title');
    var title = titleEl ? titleEl.textContent.trim() : '';

    // Split title at ' - ' for display
    var titleParts = title.split(' - ');
    var displayTitle = titleParts.length > 1
      ? '<span class="happily-sticky-atc__name">' + titleParts[0] + '</span>'
        + '<span class="happily-sticky-atc__type">' + titleParts.slice(1).join(' - ') + '</span>'
      : title;

    var priceEl = document.querySelector('.price__regular .price-item--regular, .price-item--regular');
    var priceText = priceEl ? priceEl.textContent.trim() : '';

    bar = document.createElement('div');
    bar.id = 'happily-sticky-atc';
    bar.className = 'happily-sticky-atc';
    bar.innerHTML =
      '<div class="happily-sticky-atc__inner">' +
        '<div class="happily-sticky-atc__info">' +
          '<span class="happily-sticky-atc__title">' + displayTitle + '</span>' +
          '<span class="happily-sticky-atc__price" id="happily-sticky-price">' + priceText + '</span>' +
        '</div>' +
        '<button type="button" class="button happily-sticky-atc__btn" id="happily-sticky-btn">' +
          (mainBtn.disabled ? 'Sold out' : 'Add to Cart') +
        '</button>' +
      '</div>';

    document.body.appendChild(bar);

    var stickyBtn = document.getElementById('happily-sticky-btn');
    stickyBtn.addEventListener('click', function () {
      if (mainBtn && !mainBtn.disabled) {
        mainBtn.click();
      }
    });

    // Watch the main ATC button — show bar when it's off screen
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (bar) {
          if (entry.isIntersecting) {
            bar.classList.remove('happily-sticky-atc--visible');
          } else {
            bar.classList.add('happily-sticky-atc--visible');
          }
        }
      });
    }, { threshold: 0.2 });

    observer.observe(mainBtn);

    // Keep sticky button state in sync with main button (sold out / loading)
    var btnObserver = new MutationObserver(function () {
      if (!stickyBtn || !mainBtn) return;
      stickyBtn.disabled = mainBtn.disabled;
      var mainLabel = mainBtn.querySelector('span:not(.sold-out-message):not([aria-hidden])');
      if (mainLabel && mainLabel.textContent.trim()) {
        stickyBtn.textContent = mainLabel.textContent.trim();
      }
    });
    btnObserver.observe(mainBtn, { attributes: true, childList: true, subtree: true });

    // Update price on variant change (Dawn fires 'variant:change' on the variant-selects element)
    document.addEventListener('variant:change', updateStickyPrice);
    // Also listen for Dawn's internal currency format events
    document.addEventListener('price:updated', updateStickyPrice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createBar);
  } else {
    createBar();
  }
})();

/* ── Product page: split h1 title at " - " ──────────────────────── */
(function splitProductPageTitle() {
  function escHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function doSplit() {
    var h1 = document.querySelector('.product__title h1');
    if (!h1 || h1.querySelector('.product-title__name')) return;
    var text = h1.textContent.trim();
    var idx = text.indexOf(' - ');
    if (idx === -1) return;
    var name = text.slice(0, idx).trim();
    var type = text.slice(idx + 3).trim();
    h1.innerHTML =
      '<span class="product-title__name">' + escHtml(name) + '</span>' +
      '<span class="product-title__type">' + escHtml(type) + '</span>';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doSplit);
  } else {
    doSplit();
  }
})();

/* ── Product page: rating-wrapper → smooth-scroll to reviews ────── */
(function productRatingHotlink() {
  function doLink() {
    var wrapper = document.querySelector('.product__info-wrapper .rating-wrapper, .product__info-container .rating-wrapper');
    if (!wrapper || wrapper.closest('a')) return;

    var a = document.createElement('a');
    // Judge.me always renders its widget with id="judgeme_product_reviews"
    a.href = '#judgeme_product_reviews';
    a.style.cssText = 'text-decoration:none;color:inherit;display:block;cursor:pointer;';
    a.setAttribute('aria-label', 'Read all reviews');

    a.addEventListener('click', function (e) {
      e.preventDefault();
      // Find reviews section at click-time (guaranteed loaded by then)
      var target = document.getElementById('judgeme_product_reviews') ||
                   document.querySelector('.jdgm-rev-widg') ||
                   document.querySelector('.jdgm-widget');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    wrapper.parentNode.insertBefore(a, wrapper);
    a.appendChild(wrapper);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doLink);
  } else {
    doLink();
  }
})();
